import { render, staticRenderFns } from "./clinic-searchbar.vue?vue&type=template&id=11afbe7e&"
import script from "./clinic-searchbar.vue?vue&type=script&lang=js&"
export * from "./clinic-searchbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports